exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scroll-button{position:fixed;bottom:20px;right:20px}.scroll-button button{background-color:#007bff;color:#fff;border:none;padding:10px;cursor:pointer;display:block;margin-bottom:5px}", ""]);

// exports
